import { IntlFormatters } from 'react-intl';

import { Caption, CaptionType } from '../../../models/caption/Caption';

import { messages } from './messages';

export const getCaptionText = (
  caption: Caption,
  formatMessage: IntlFormatters['formatMessage']
): string =>
  caption.type === CaptionType.EXTERNAL
    ? caption.caption
    : messages[caption.caption] && formatMessage(messages[caption.caption]);

export const getCaptionFullText = (
  mainText: string,
  additionalText?: string
): string => mainText + (additionalText ? `\u00A0(${additionalText})` : '');
